import { FunctionComponent, useEffect, useState } from 'react';
import { Document, pdfjs, Page } from 'react-pdf';
import { useTranslation } from 'react-i18next';
import { Card } from 'antd';

// components
import { getContractUrlRequest } from 'modules/main/auth/register/services/agreementService';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import FilePreview from 'components/filePreview/filePreview';
import NotificationService from 'core/services/notification';
import NoData from 'components/noData/noData';

import { getViewerWidth } from 'utils/fileViewerWidth';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const SubscriptionContractComponent: FunctionComponent = () => {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [contractUrl, setContractUrl] = useState<string>();
	const [numOfPages, setNumOfPages] = useState<number>(0);
	const [containerWidth, setContainerWidth] = useState<number>(getViewerWidth());

	useEffect(() => {
		getSubscriptionContractUrl();

		const handleResize = () => {
			setContainerWidth(getViewerWidth());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
		setNumOfPages(numPages);
	};

	const getSubscriptionContractUrl = async () => {
		try {
			setIsLoading(true);

			const { platform_use_contract_template } = await getContractUrlRequest();

			setContractUrl(platform_use_contract_template);

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
		}
	};

	return (
		<>
			<Card>
				{isLoading ? (
					<LoadingComponent />
				) : contractUrl ? (
					<>
						<Document
							file={contractUrl}
							onLoadSuccess={onDocumentLoadSuccess}
							className="agreementPdf"
							loading={<></>}>
							{Array.from({ length: numOfPages }, (_, i) => (
								<Page loading={<></>} pageNumber={i + 1} scale={1} width={containerWidth} key={i} />
							))}
						</Document>

						<div className="m-auto" style={{ width: getViewerWidth() }}>
							<FilePreview name={t('REGISTER.HEFTH_SERVICES_AGREEMENTS')} className="my-4" downloadLink={contractUrl} />
						</div>
					</>
				) : (
					<NoData />
				)}
			</Card>
		</>
	);
};

export default SubscriptionContractComponent;
